import { accessContract } from '@mntn/api-contracts/flight-deck/v1/access'
import { skipToken, useQuery } from '@tanstack/react-query'
import { useFlightDeckTsRestClient } from '@/flight-deck-api/ts-rest'

export const useAdvertiserService = () => {
  const accessClient = useFlightDeckTsRestClient(accessContract)

  return {
    getAdvertiserAccess: {
      handler: async ({ advertiserId }: { advertiserId: number }) => {
        const response = await accessClient.check({
          query: { 'advertiser-id': advertiserId },
        })

        if (response.status !== 200) {
          throw new Error('There was an issue checking access. Try again.')
        }

        // Endpoint returns format: { data: { flightDeck: boolean, storefront: boolean } }
        return response.body
      },
    },
  }
}

export const useAdvertiserAccess = (advertiserId: number | undefined) => {
  const { getAdvertiserAccess } = useAdvertiserService()

  const result = useQuery({
    queryKey: ['advertiser-access', advertiserId],
    queryFn: advertiserId
      ? // biome-ignore lint/plugin: RETIRED, do not copy. Call it through useSelectQuery/useSelectMutation when touching this.
        () => getAdvertiserAccess.handler({ advertiserId })
      : skipToken,
  })

  const defaultData = { flightDeck: false, storefront: false }
  return {
    ...result,
    data: result.data ?? { data: defaultData },
  }
}
